import LocalOfferOutlined from '@mui/icons-material/LocalOfferOutlined';
import AccessibilityNewOutlined from '@mui/icons-material/AccessibilityNewOutlined';
import SelfImprovementOutlined from '@mui/icons-material/SelfImprovementOutlined';
import DocPageLayout from './DocPageLayout.js';
import './DocPage.css';

const heroImage = '/img/full-body-balance.webp';
const secondaryImage = '/img/hero-treatment.jpg';

const CampaignFullBodyBalance = () => (
    <DocPageLayout
        currentRoute="/campaign/full-body-balance"
        pageLabel="CAMPAIGN"
        pageTitle="全身バランス調整50分 キャンペーン"
        heroImage={heroImage}
        heroImageAlt="全身バランス調整の施術"
        heroHighlight="身体の歪みを整えて自然治癒力を高める"
        heroDescription={[
            '骨格・筋肉・神経のバランスを整え、疲れにくく回復しやすい身体づくりをサポートします。',
            '生活習慣による歪みを見直し、自然治癒力の働きを最大限に引き出しましょう。'
        ]}
    >
        <article className="doc-section">
            <h3 className="doc-section__title">
                <LocalOfferOutlined className="doc-section__icon" />キャンペーン概要
            </h3>
            <div className="doc-section__body">
                <p>
                    重力や生活習慣によって崩れた身体のバランスを整える特別プランです。
                    予約ページで「キャンペーン 全身バランス調整」を選択してください。
                </p>
                <div className="doc-highlight">
                    <p><strong>施術内容</strong> 神経整体 初回 75分 / 2回目以降 50分</p>
                    <p><strong>特別価格</strong> 11,000円 → 7,700円</p>
                    <p className="doc-note">※キャンペーンは予告なく終了する場合があります。</p>
                </div>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <AccessibilityNewOutlined className="doc-section__icon" />身体バランスの重要性
            </h3>
            <div className="doc-section__body">
                <p>
                    日常生活のクセや姿勢の乱れにより身体のバランスが崩れると、疲労や痛みが蓄積します。
                    バランスを整えることで、正しい姿勢を維持しやすくなり、ケガの予防や回復力向上につながります。
                </p>
                <div className="doc-section__media">
                    <img src={secondaryImage} alt="全身調整の施術イメージ" loading="lazy" />
                </div>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <SelfImprovementOutlined className="doc-section__icon" />こんな方におすすめ
            </h3>
            <div className="doc-section__body">
                <p>
                    姿勢が気になる、疲れが抜けにくい、スポーツや仕事で身体に偏りがある方に。
                    全身の巡りを整え、より快適に動ける身体を目指します。
                </p>
            </div>
        </article>
    </DocPageLayout>
);

export default CampaignFullBodyBalance;
